<template>
	<v-container fluid grid-list-md>
		<v-data-iterator
			row
			wrap
			content-tag="v-layout"
			:items="actions"
			:total-items="actions.length"
			item-key="id"
			hide-actions
			disable-initial-sort>

			<v-flex slot="item" slot-scope="props" xs12 sm6 md4 lg4>
				<action-grid-item :action="props.item" />
			</v-flex>
		</v-data-iterator>
	</v-container>
</template>


<script>
import ActionGridItem from "@/components/ActionGridItem.vue";


export default {
	name: "action-grid",
	components: { ActionGridItem },
	props: {
		'actions': { type: Array, default: () => [] },
	},
	data: () => ({
		possibleNbRows: [50],
		pagination: {
			sortBy: 'title',
			descending: false, 
			page: 1,
			rowsPerPage: 50,
			totalItems: 0,
		},
	}),
};
</script>
